module.exports = __webpack_public_path__ + "img/album21_19.8425f285.jpg";